<template>
  <div class='alarms'>
    Alarms View
  </div>
</template>

<script>
export default {
  name: 'alarms',
  data() {
    return {
    }
  }
}
</script>

<style scoped>
  /*.alarms {
  }*/
</style>